<template>
  <div>
    <header class="header">
      <div class="header-left">
        <a>
          <img src="/static/image/top_bg_right-1.png" />
        </a>
      </div>
      <div class="top-right">
        <div class="user-login" v-if="$store.state.token">
          <a @click="$parent.goNav('/')">{{ $t('header.home') }}</a> &nbsp;|&nbsp;
          <a class="shiwan" @click="$parent.goNav('/mine/center')">{{ $store.state.userInfo.username ? $store.state.userInfo.username : '' }}</a>
          &nbsp;|&nbsp; <a @click="outLogin">{{ $t('header.Signout') }}</a>
        </div>
        <div class="user-login" v-else>
          <a @click="$parent.goNav('/')"
            ><font style="vertical-align: inherit"
              ><font style="vertical-align: inherit">{{ $t('header.home') }}</font></font
            ></a
          ><font style="vertical-align: inherit"
            ><font style="vertical-align: inherit"> &nbsp;| </font><font style="vertical-align: inherit">{{ $t('header.Notmember') }} </font></font
          ><a @click="$parent.goNav('/register')"
            ><font style="vertical-align: inherit"
              ><font style="vertical-align: inherit">{{ $t('header.register') }}</font></font
            ></a
          >
        </div>
        <a v-if="$store.state.token" @click="$parent.goNav('/activityapyList')" target="_blank" class="free-demo">
          <div class="free-dem-a">{{ $t('header.review') }}</div>
        </a>
        <a v-else @click="$parent.goNav('/login')" target="_blank" class="free-demo">
          <div class="free-dem-a">{{ $t('header.review') }}</div>
        </a>
      </div>

      <img style="margin-top: -55px" class="header-logo" src="/static/image/logo1-1.png" />
    </header>
    <div class="app-content view-slideup on" v-if="dataInfo.title">
      <div class="activity-city">
        <div class="activity-content">
          <div id="result" style="min-height: 400px">
            <div class="at-content" style="padding-top: 20px">
              <p class="at-title">{{ dataInfo.title }}</p>
              <div class="at-mlu">{{ $t('index.activity') }}</div>
              <div class="at-detail" v-html="dataInfo.content"></div>
              <div class="at-mlu">{{ $t('index.Event') }}</div>
              <div class="at-detail" v-html="dataInfo.memo"></div>
              <div class="at-mlu">{{ $t('index.How') }}</div>
              <div class="at-detail">
                <p>{{ $t('index.Eligible') }}</p>
                <div class="container box">
                  <div class="user-section login-section">
                    <div class="logon-tab">&gt;&gt; {{ $t('index.Please') }}</div>
                    <div class="login-main">
                      <form class="form-vertical nice-validator n-default n-bootstrap">
                        <label for="account" class="control-label"> {{ $t('index.member') }}</label>
                        <div class="controls">
                          <input id="account" type="text" name="account" :value="$store.state.userInfo.username || ''" :placeholder="$t('index.fill')" autocomplete="off" class="form-control input-lg" />
                          <div class="help-block"></div>
                        </div>
                        <label for="account" class="control-label"> {{ $t('all.Pleaseenjoy') }}</label>

                        <div class="controls">
                          <input id="account" type="text" name="account" v-model="amount" :placeholder="$t('all.Fillamount')" oninput="value=value.replace(/[^0-9]/g,'')" autocomplete="off" class="form-control input-lg" />
                          <div class="help-block"></div>
                        </div>
                        <div class="form-group">
                          <!-- <div class="controls">*{{ $t('index.will') }}{{ $t('index.thanks') }}</div> -->
                        </div>
                        <input type="hidden" class="form-control input-lg" value="10" />
                        <div class="form-group">
                          <div loading="0" v-if="$store.state.token && dataInfo.can_apply == 1" @click="doactivityapply" class="btn btn-primary btn-lg btn-block">{{ $t('index.application') }}</div>
                          <!---->
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="content">
        <div class="sponsors"></div>
        <div class="foot-nav">
          <div class="copyright all-rights">© 2022 {{ $store.state.appInfo.title }} {{ $t('foot.All') }}.</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'activityInfo',
  data() {
    return { dataInfo: {}, amount: null };
  },
  created() {
    let that = this;
    let query = that.$route.query;
    if (query.id) {
      that.getInfo(query.id);
    }
  },
  methods: {
    outLogin() {
      let that = this;
      that.$parent.outLogin();
    },
    getInfo(id) {
      let that = this;
      that.$parent.showLoading();
      that.$apiFun.post('/api/activitydeatil', { id }).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.$parent.showTost(0, res.message);
        }
        if (res.code === 200) {
          that.dataInfo = res.data;
        }
        that.$parent.hideLoading();
      });
    },
    doactivityapply() {
      let that = this;

      that.$parent.showLoading();
      that.$apiFun.post('/api/doactivityapply', { activityid: that.dataInfo.id, amount: that.amount }).then(res => {
        that.$parent.hideLoading();
        that.$parent.showTost(1, res.message);
      });
    },
  },
  mounted() {
    let that = this;
  },
  updated() {
    let that = this;
  },
  beforeDestroy() {},
};
</script>
<style lang="scss" scoped>
@import '../../static/css/style.css';
@import '../../static/css/bootstrap.min.css';

html,
body {
  font-family: Arial, 'Microsoft JhengHei', sans-serif;
}
label {
  font-weight: 400;
}
.at-content {
  width: 100%;
  overflow: hidden;
  position: relative;
  z-index: 99;
}
.at-mlu {
  height: 43px;
  color: rgb(255, 242, 155);
  font-size: 17px;
  line-height: 43px;
  width: 170px;
  text-align: center;

  background: url(/mb10/activity/img/xpj_prospirit.png) no-repeat 0px 0px;
  background-size: auto 43px;
}
.at-detail {
  margin: 10px 30px;
  line-height: 26px;
  color: rgb(51, 51, 51);
  font-size: 15px;
}
.at-font-red {
  color: red;
}
input {
  border-style: none;
}
.clearfix:after {
  content: '.';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.box {
  position: relative;
  border-radius: 3px;
  background: #ffffff;
  border-top: 3px solid #e74c3c;
  margin-bottom: 20px;
  width: 100%;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
  padding: 20px 5%;
  margin-top: 20px;
  width: 500px;
}
.logon-tab {
  color: #666;
  margin-bottom: 10px;
  font-size: 13px;
}
.controls {
  color: #666;
  font-size: 13px;
  margin-top: 15px;
}
.activity-image {
  height: 120px;
  width: auto;
  margin: 0 auto;
  margin-bottom: 12px;
}
@media screen and (max-width: 768px) {
  .at-detail {
    margin: 5px 10px;
  }
  .at-mlu {
    height: 35px;
    line-height: 35px;
    background-size: auto 35px;
    width: 140px;
    font-size: 14px;
  }
}

.table-bordered {
  margin-top: 10px;
}
.at-tr.at-font-red td {
  background: #f5f5f5;
  color: #999;
}
.at-tr {
  text-align: center;
}
.at-title {
  font-size: 30px;
  text-align: center;
  color: #333;
  margin-top: 15px;
}
@media screen and (max-width: 768px) {
  .at-tr td {
    font-size: 13px;
  }
  .at-title {
    font-size: 20px;
  }
  .box {
    width: 100%;
  }
}

.header-logo {
  width: auto;
  height: 55px;
  margin: -55px auto 0 auto;
  display: inherit;
}
.app-content {
  top: 90px;
}
.activity-content {
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
  background: #fff;
}
#result {
  font-size: 16px;
  color: #aaa;
}
.activity-sub {
  width: 100%;
  margin: 0 auto;
  border: 1px solid #ba924a;
  border-radius: 5px;
  margin-top: 15px;
  margin-bottom: 15px;
  padding-bottom: 15px;
  display: -webkit-box;
}
.form-input {
  display: block;
  width: 100%;
  height: 34px;
  font-size: 14px;
  line-height: 1.42857143;
  color: #555;
  background-color: #fff;
  background-image: none;
  border: 1px solid #ccc;
  border-radius: 3px;
  -webkit-box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  box-shadow: inset 0 1px 1px rgba(0, 0, 0, 0.075);
  -webkit-transition: border-color ease-in-out 0.15s, -webkit-box-shadow ease-in-out 0.15s;
  -o-transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  transition: border-color ease-in-out 0.15s, box-shadow ease-in-out 0.15s;
  color: #000;
  box-sizing: border-box;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  padding: 6px 12px;
}
.from-title {
  line-height: 40px;
  color: #ccc;
}
.form-btn {
  margin-top: 30px;
  line-height: 40px;
  height: 40px;
  border-radius: 3px;
  left: 50%;
  margin-left: -95px;
}
.form-group {
  -webkit-box-flex: 1;
  position: relative;
}
.free-demo {
  font-size: 16px;
  font-weight: bold;
  color: #fff;
  display: block;
  width: 190px;
  height: 44px;
  float: left;
  text-align: center;
  line-height: 44px;
  background: #cca352;
  position: relative;
  transition: all 0.2s;
  overflow: hidden;
}
.free-dem-a {
  color: #fff;
  font-size: 16px;
}
.free-demo:after {
  content: '';
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.2);
  transform: rotate(-45deg);
  position: absolute;
  top: -10%;
  left: -100%;
  transition: 0.6s ease;
}
.free-demo:hover {
  background: #ba8d4d;
}
.free-demo:hover:after {
  animation: cv-submit-hover 0.8s ease;
}

@keyframes cv-submit-hover {
  0% {
    left: -100%;
  }
  100% {
    left: 100%;
  }
}
.group-content {
  width: 80%;
  max-width: 300px;
  position: absolute;
  right: 0;
}
.activity-image {
  margin-bottom: 5px;
}

.footer {
  margin-top: 100px;
}

html,
body {
  font-family: Arial, 'Microsoft JhengHei', sans-serif;
}
label {
  font-weight: 400;
}
.at-content {
  width: 100%;
  overflow: hidden;
  position: relative;
  z-index: 99;
}
.at-mlu {
  height: 43px;
  color: rgb(255, 242, 155);
  font-size: 17px;
  line-height: 43px;
  width: 170px;
  text-align: center;
  background: url(/static/image/xpj_prospirit.png) no-repeat 0px 0px;
  background-size: auto 43px;
}
.at-detail {
  margin: 10px 30px;
  line-height: 26px;
  color: rgb(51, 51, 51);
  font-size: 15px;
}
.at-font-red {
  color: red;
}
input {
  border-style: none;
}
.clearfix:after {
  content: '.';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}
.box {
  position: relative;
  border-radius: 3px;
  background: #ffffff;
  border-top: 3px solid #e74c3c;
  margin-bottom: 20px;
  width: 100%;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
  padding: 20px 5%;
  margin-top: 20px;
  width: 500px;
}
.logon-tab {
  color: #666;
  margin-bottom: 10px;
  font-size: 13px;
}
.controls {
  color: #666;
  font-size: 13px;
  margin-top: 15px;
}

.activity-image {
  display: block;
}
.activity-image1 {
  display: none;
}

@media screen and (max-width: 768px) {
  .header-logo {
    display: none;
  }

  .app-content {
    top: 60px;
  }
  .image-back {
    top: 45px;
  }
  .activity-image1 {
    width: 100%;
    margin-bottom: 10px;
  }
  .footer {
    margin-top: 70px;
  }
  .at-detail {
    margin: 5px 10px;
  }
  .at-mlu {
    height: 35px;
    line-height: 35px;
    background-size: auto 35px;
    width: 140px;
    font-size: 14px;
  }
  .activity-image {
    display: none;
  }
  .activity-image1 {
    display: block;
  }
}
.at-mlu[data-v-600c85ed] {
  width: 100% !important;
}
</style>



// WEBPACK FOOTER //
// src/components/activityInfo.vue